import React, { useState, useEffect, useRef } from "react";
import trackhrlogo from "./assets/trackhrlogo.png";
import { Layout, Menu, Tooltip, Spin, Pagination, Space, Button, Input } from "antd";
import {
  DashboardOutlined,
  UserAddOutlined,
  FileSearchOutlined,
  CalendarOutlined,
  FileDoneOutlined,
  PauseCircleOutlined,
  CloseCircleOutlined,
  TeamOutlined,
  BarChartOutlined,
  AppstoreOutlined,
  PlusOutlined,
  SearchOutlined,
  FilterOutlined,
  PoweroffOutlined,
  ReloadOutlined,
  DownloadOutlined,
  UploadOutlined,
  LogoutOutlined
} from "@ant-design/icons";
import Hexapi from "./utility/HexAPI/Hexapi.js";
import Show from "./component/show.js";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Filter from "./Filters/Filter";
import "react-confirm-alert/src/react-confirm-alert.css";
import { confirmAlert } from "react-confirm-alert";
import Swal from "sweetalert2";
import ImportFile from "./Excel/ImportFile";
import ExportFile from "./Excel/ExportFile";
import Hexapi2 from "./utility/HexAPI/Hexapi2.js";
import ActionModal from "./component/actionmodal.js";
import ReminderNotification from "./component/ReminderNotification";
import QuickSearch from "./component/QuickSearch";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import CustomerEnquiryform from "./pages/customerenquiry/customerEnquiry.js";
import { FiLogOut } from "react-icons/fi";
import Loader from "./component/loader/Loader.js";
import { Aesencryption } from "./utility/Aes/Aes.js";
import Generatelinks from "./pages/Generatelinks.js";
const { Sider, Header, Content } = Layout;

const NAV_SECTIONS = [
  {
    items: [
      { key: "New", label: "New Application", icon: <UserAddOutlined />, tabvalue: "2" },
      { key: "Screening", label: "Screening", icon: <FileSearchOutlined />, tabvalue: "3" },
      { key: "Shortlisted", label: "Shortlisted", icon: <TeamOutlined />, tabvalue: "4" },
      { key: "Interview", label: "Interview", icon: <CalendarOutlined />, tabvalue: "5" },
      { key: "Selected", label: "Selected", icon: <FileDoneOutlined />, tabvalue: "8" },
      { key: "Offer", label: "Offer Released", icon: <FileSearchOutlined />, tabvalue: "9" },
      { key: "Joined", label: "Joined", icon: <TeamOutlined />, tabvalue: "10" },
      { key: "Rejected", label: "Rejected", icon: <CloseCircleOutlined />, tabvalue: "11" },
      { key: "OnHold", label: "On Hold", icon: <PauseCircleOutlined />, tabvalue: "12" },
      { key: "All", label: "All Candidates", icon: <AppstoreOutlined />, tabvalue: "0" },
    ],
  },
];
const IconLink = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="22">
    <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/>
    <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/>
  </svg>
)
const NAV_FLAT = NAV_SECTIONS.flatMap((s) => s.items);

const Main = ({ sessionid}) => {
  const [value, setValue] = useState(localStorage.getItem("activeTab") || "1");
  const [excelDownloadUrl] = useState(`${localStorage.getItem("Apipathurl")}Examples/GenerateExcelNew.php`);
  const [fetchRsUrl] = useState(`${localStorage.getItem("Apipathurl")}fetchrsdataV2.php`);
  const [leadtypes, setLeadtypes] = useState(localStorage.getItem("leadtype") || "0");
  const [limit, setLimit] = useState("100");
  const [searchdata, setSearchdata] = useState("");
  const [pagenumber, setPagenumber] = useState("1");
  const [totalpagenumber, setTotalpagenumber] = useState([]);
  const [header, setHeader] = useState([]);
  const [headerkeys, setHeaderkeys] = useState([]);
  const [isDataAvailable, setIsDataAvailable] = useState(true);
  const [istableapihitcomplete, setIstableapihitcomplete] = useState(true);
  const [logoutshow, setLogoutshow] = useState(false);
  const [appliedFilter, setAppliedFilter] = useState("-1");
  const [iscountapihitcomplete, setIscountapihitcomplete] = useState(false);
  const [isCountAvailable, setIsCountAvailable] = useState(false);
  const [filters, setFilters] = useState([]);
  const [enddate, setEnddate] = useState("");
  const [startdate, setStartdate] = useState("");
  const [headerpara, setHeaderpara] = useState("");
  const [totalcount, setTotalcount] = useState("");
  const [totalcounttext, setTotalcounttext] = useState("");
  const [stagesummary,setstagesummary]=useState(null)
  const [showgeneratelink,setshowgeneratelink]=useState(false)
  const [isfilterclear, setIsfilterclear] = useState(true);
  const [cidarray, setCidarray] = useState([]);
  const [stageidarr, setStageidarr] = useState([]);
  const [selectrowcount] = useState([
    { name: 10, id: 10 },
    { name: 20, id: 20 },
    { name: 30, id: 30 },
    { name: 100, id: 100 },
  ]);
  const [Selectedrowindex, setSelectedrowindex] = useState(null);
  const [modalshow, setModalshow] = useState(false);
  const [recid, setRecid] = useState(null);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [searchExecuted, setSearchExecuted] = useState(false);
  const [isSearchRunning, setIsSearchRunning] = useState(false);
  const [isnewvalue, setIsnewvalue] = useState(null);
  const [notification, setNotification] = useState(null);
  const [addleadshow, setaddleadshow] = useState(false);
  const [productpanel, setproductpanel] = useState(false);
  const [siderCollapsed, setSiderCollapsed] = useState(false);
const [agentid,setAgentid]=useState(null)
const [agentname,setAgentname]=useState(null)
const [usertype,setusertype]=useState(null)
const [loading,setLoading]=useState(false)
  const tableRef = useRef(null);
  const showRef = useRef(null);
  const searchInputRef = useRef(null);
  const controllerRef = useRef(null);
const [agentnameonlogout] = useState(agentname);
  const valueRef = useRef(value);
  const limitRef = useRef(limit);
  const searchdataRef = useRef(searchdata);
  const pagenumberRef = useRef(pagenumber);
  const leadtypesRef = useRef(leadtypes);
  const appliedFilterRef = useRef(appliedFilter);
  const startdateRef = useRef(startdate);
  const enddateRef = useRef(enddate);
  const notificationRef = useRef(notification);
const originalDataRef = useRef([]);
  // Tracks the currently active "Applied For" selection for the tab currently on screen
  // (e.g. closing ActionModal triggers refreshtable -> filterdataapi, which used to reset filters)
  const appliedPositionFilterRef = useRef([]);
  // Remembers each tab's own "Applied For" selection separately, keyed by leadtype value,
  // so switching tabs restores that tab's filter instead of sharing one global filter.
  const positionFilterByTabRef = useRef({});
  // appliedposition can be a plain string (single value or comma-separated) or an array — normalize to array
  const toPositionArray = (val) => (Array.isArray(val) ? val : (val || "").split(","));
  const navigate = useNavigate();

  useEffect(() => { valueRef.current = value; }, [value]);
  useEffect(() => { limitRef.current = limit; }, [limit]);
  useEffect(() => { searchdataRef.current = searchdata; }, [searchdata]);
  useEffect(() => { pagenumberRef.current = pagenumber; }, [pagenumber]);
  useEffect(() => { leadtypesRef.current = leadtypes; }, [leadtypes]);
  useEffect(() => { appliedFilterRef.current = appliedFilter; }, [appliedFilter]);
  useEffect(() => { startdateRef.current = startdate; }, [startdate]);
  useEffect(() => { enddateRef.current = enddate; }, [enddate]);
  useEffect(() => { notificationRef.current = notification; }, [notification]);

 

  const toggleSearchInput = () => {
    if (!showSearchInput) {
      setShowSearchInput(true);
      setSearchExecuted(false);
      setTimeout(() => {
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }, 0);
      return;
    }
    if (!searchdataRef.current || searchdataRef.current.trim() === "") {
      setShowSearchInput(false);
      setSearchExecuted(false);
      return;
    }
    searchbuttonclick();
  };

  const decodeUrl = (url) => {
    if (!url.includes("?")) return null;
    const encrypted = url.split("?")[1];
    const decrypted = atob(encrypted);
    if (!decrypted) return null;
    return Object.fromEntries(new URLSearchParams(decrypted));
  };
  const handlelogindata = async (sessionid) => {
    try {
      const obj = {
        query: `[dbo].[HCMS_Proc_User_GetDetailsV2] @SessionID='{0}'`,
        queryArr: [`${sessionid}`],
      };

      const resp = await Hexapi(obj);

      if (resp && resp[""] && resp[""][0]) {
        console.log(resp,"resp")
        setAgentid(resp[""][0].agentid);
        setAgentname(resp[""][0].agentname);
        setusertype(resp[""][0].usertype)
      } else {
        
        localStorage.removeItem("sessionid");
      }
    } catch (error) {
      console.log(error);
      localStorage.removeItem("sessionid");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  
    const session = localStorage.getItem("sessionid") ;

    if (session) {
      handlelogindata(session);
    } else {
  
    }
  }, []);
  const fetchNotification = async () => {
    try {
      const resp = await Hexapi({
        query: `[dbo].[HCMS_Proc_TeleCMICall_Notification_GetData] @AgentID='{0}'`,
        queryArr: [`${agentid}`],
      });
      if (resp && resp[""] && resp[""].length > 0) {
        const { command, msg, enquiryid } = resp[""][0];
        const previousEnquiryId = notificationRef.current?.enquiryid;
        if (command === 1) {
          if (enquiryid !== previousEnquiryId) {
            if (previousEnquiryId) toast.dismiss(`enquiry_${previousEnquiryId}`);
            setNotification({ msg: msg, enquiryid: enquiryid });
            toast.success(
              <div onClick={() => openrowapp(enquiryid, true)} dangerouslySetInnerHTML={{ __html: msg }} />,
              { position: "bottom-left", duration: Infinity, id: `enquiry_${enquiryid}` }
            );
          }
        } else if (command === 0) {
          if (previousEnquiryId) {
            toast.dismiss(`enquiry_${previousEnquiryId}`);
            setNotification(null);
          }
        }
      }
    } catch (err) {
      console.error("NOtification fetch error:", err);
    }
  };

  const openrowapp = (enquiryid, fromToast = false) => {
    openActionModal(enquiryid);
  };

  const formatDateToDDMMYYYY = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const convertToDate = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  };

  const handledatechageend = (e) => {
    const val = e.target.value;
    setEnddate(val);
    enddateRef.current = val;
    validateDates(startdateRef.current, val);
  };

  const handledatechagestart = (e) => {
    const val = e.target.value;
    setStartdate(val);
    startdateRef.current = val;
    validateDates(val, enddateRef.current);
  };

  const validateDates = (start, end) => {
    const startDateObj = new Date(start);
    const endDateObj = new Date(end);
    if (start && end) {
      if (startDateObj > endDateObj) {
        Swal.fire({ title: "Oops...", text: "Start date cannot be greater than end date" });
      } else if (endDateObj < startDateObj) {
        Swal.fire({ title: "Oops...", text: "End date cannot be smaller than start date" });
      } else {
        datewisereport(limitRef.current);
      }
    }
  };

  const enquirycount = async (filter, signal) => {
    setIscountapihitcomplete(false);
    setIsCountAvailable(false);
    const lim = limitRef.current === "" ? "100" : limitRef.current;
    const sd = searchdataRef.current === "" ? "-1" : searchdataRef.current;
    
    const obj = {
      query: `[dbo].[HCMS_Proc_Leads_Count] @AgentID='{0}', @Searchdata ='{1}', @LeadType='{2}',@Filter='{3}',@Limit='{4}'`,
      queryArr: [`${agentid}`, `${sd}`, `${leadtypesRef.current}`, `${filter}`, `${lim}`],
    };
    try {
      const resp = await Hexapi2(obj, { signal });
      if (resp[""] && resp[""][0].cntrows !== undefined && resp[""][0].cntrows !== 0) {
        const pages = Math.ceil(resp[""][0].cntrows / limitRef.current);
        setTotalpagenumber(pages);
        setTotalcount(resp[""][0].cntrows);
        setIsCountAvailable(true);
        setTotalcounttext(resp[""][0].cnttext);
      } else {
        setIsCountAvailable(false);
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("enquirycount request canceled");
      } else {
        console.error("Error fetching count:", error);
      }
    } finally {
      setIscountapihitcomplete(true);
    }
  };

  const refreshtableadd=()=>{
filterdataapi(appliedFilterRef.current, limitRef.current);
  }

  const filterdataapi = async (filter, lim) => {
    setTotalcount(null)
    if (controllerRef.current) controllerRef.current.abort();
    controllerRef.current = new AbortController();
    const { signal } = controllerRef.current;
    setIstableapihitcomplete(false);
    setIsDataAvailable(false);
    setAppliedFilter(filter);
    appliedFilterRef.current = filter;
    if (lim === "") lim = 100;
    const sd = searchdataRef.current === "" ? "-1" : searchdataRef.current;
    try {
      await enquirycount(filter, signal);
    } catch (error) {
      if (error.name === "AbortError") { console.log("enquirycount request canceled"); return; }
    }
    
    const obj = {
      query: `[dbo].[HCMS_Proc_Get_Candidates_List] @PageNo='{0}', @AgentID='{1}', @Searchdata ='{2}', @CandidateType='{3}', @Filter='{4}', @Limit='{5}'`,
      queryArr: [`${pagenumberRef.current}`, `${agentid}`, `${sd}`, `${leadtypesRef.current}`, `${filter}`, `${lim}`],
    };
    try {
      const resp = await Hexapi2(obj, { signal });
      console.log(resp,"resp")
      if (resp.filters !== undefined && resp.filters.length > 0 && filter == -1) setFilters(resp.filters);
      // setHeaderpara(resp.info[0].header);
      if (resp && resp["reportdata"].length > 0) {
        console.log(resp,"tvvghrbhfjnkdskbghvnjkfk")
        const keys = Object.keys(resp["reportdata"][0]);
        const sortedreportcid = resp["reportdata"].map((item) => item.enquiryid);
        const cleanHTML = (html) => { const div = document.createElement("div"); div.innerHTML = html; return div.textContent || div.innerText || ""; };
        const processedData = resp["reportdata"].map((item) => ({ contactID: cleanHTML(item["enquiryid"]), stage: item.stageid, customerNumber: item["contact number"] }));
        setHeaderkeys(keys);
        setstagesummary(resp?.stagesummary?.[0]?.stagesummary)
        originalDataRef.current = resp["reportdata"];
        setIsDataAvailable(true);
        setCidarray(sortedreportcid);
        setStageidarr(processedData);

        // Build "Applied For" filter options from the data itself (client-side filter, no backend involvement)
        // appliedposition can be a plain string (single value or comma-separated) or an array — normalize to array
        const uniquePositions = [...new Set(
          resp["reportdata"]
            .flatMap((item) => toPositionArray(item.appliedposition).map((p) => (p || "").trim()))
            .filter(Boolean)
        )];

        // If an "Applied For" filter is currently active (e.g. table is being refreshed after
        // closing ActionModal), re-apply it to the freshly fetched data instead of resetting to all.
        const activeSelected = appliedPositionFilterRef.current || [];
        const filteredData = activeSelected.length > 0
          ? resp["reportdata"].filter((item) => {
              const itemPositions = toPositionArray(item.appliedposition).map((p) => (p || "").trim());
              return itemPositions.some((pos) => activeSelected.includes(pos));
            })
          : resp["reportdata"];

        setHeader(filteredData);
        setTotalcount(filteredData.length);

        setFilters([{
          filtername: "Applied For",
          filtertype: 1003,
          values: uniquePositions.join(","),
          defval: activeSelected.length > 0 ? activeSelected.join(",") : uniquePositions.join(","),
        }]);

        console.log(processedData,"processeddata")
      } else {
        setIsDataAvailable(false);
      }
    } catch (error) {
      if (error.name === "AbortError") { console.log("filterdataapi request canceled"); }
      else { console.error("Error fetching data:", error); }
    } finally {
      setIstableapihitcomplete(true);
    }
  };

  useEffect(() => {
    if (agentid === "" || agentid == undefined || agentid ==null) return;
    if (valueRef.current === "Date wise Report") {
      datewisereport(limitRef.current);
    } else if (valueRef.current === "usage") {
      // no-op
    } else {
      filterdataapi(-1, limitRef.current);
    }
    if (window.location.href.includes("?")) {
      const Data = decodeUrl(window.location.href);
      if (Data && Data.EnquiryID) openActionModal(Data.EnquiryID);
    }
    const today = new Date();
    const endDate = today.toISOString().split("T")[0];
    const oneMonth = new Date(today.setMonth(today.getMonth() - 1));
    const startDate = oneMonth.toISOString().split("T")[0];
    setStartdate(startDate);
    setEnddate(endDate);
    startdateRef.current = startDate;
    enddateRef.current = endDate;
    // const interval = setInterval(() => { fetchNotification(); }, 5000);
    // fetchNotification();
    requestAnimationFrame(() => { window.dispatchEvent(new Event("resize")); });
    // return () => clearInterval(interval);
  
  }, [agentid]);

  const openActionModal = (EnquiryID) => { setModalshow(true); setRecid(EnquiryID); };

  const searchInput = (e) => { setSearchdata(e.target.value); searchdataRef.current = e.target.value; };

  const tabChange = (e, newvalue) => {
    console.log(newvalue,"newValue")
    e.preventDefault();
    if (newvalue == "productpanel") { setproductpanel(true); return; }
    if(newvalue !=="Dashboard"){
localStorage.setItem("activeTab", newvalue);
    setIsnewvalue(newvalue);
    }
    
    if (newvalue == "Date wise Report") {
      setValue(newvalue); valueRef.current = newvalue;
      setHeader([]); setHeaderkeys([]); setHeaderpara(""); setFilters([]);
      appliedPositionFilterRef.current = [];
      datewisereport(limitRef.current);
    } else if (newvalue === "usage") {
      setValue(newvalue); valueRef.current = newvalue;
      usageChange();
    } else if (newvalue != "Dashboard") {
      localStorage.setItem("leadtype", newvalue);
      setLeadtypes(newvalue); leadtypesRef.current = newvalue;
      setValue(newvalue); valueRef.current = newvalue;
      setHeader([]); setHeaderkeys([]); setHeaderpara(""); setFilters([]);
      const restoredFilter = positionFilterByTabRef.current[newvalue] || [];
      appliedPositionFilterRef.current = restoredFilter;
      setIsfilterclear(restoredFilter.length === 0);
      filterdataapi(-1, limitRef.current);
    } else {
      setValue(newvalue); valueRef.current = newvalue;
    }
  };

  const enquirydata = async (signal) => {
    setIscountapihitcomplete(false);
    setIsCountAvailable(false);
    const lim = limitRef.current == "" ? "100" : limitRef.current;
    const sd = searchdataRef.current == "" ? "-1" : searchdataRef.current;

    try {
      const obj = {
        query: ` [dbo].[HCMS_Proc_DatewiseLeads_Count]@PageNo='{0}',@AgentID='{1}',@Searchdata='{2}',@StartDate='{3}',@EndDate='{4}',@Limit='{5}'`,
        queryArr: [`${pagenumberRef.current}`, `${agentid}`, `${sd}`, `${startdateRef.current}`, `${enddateRef.current}`, `${lim}`],
      };
      const resp = await Hexapi2(obj, { signal });
      if (resp[""][0].cntrows != undefined && resp[""][0].cntrows != 0) {
        const pages = Math.ceil(resp[""][0].cntrows / limitRef.current);
        setTotalpagenumber(pages);
        setTotalcount(resp[""][0].cntrows);
        setIsCountAvailable(true);
        setTotalcounttext(resp[""][0].cnttext);
      } else {
        setIsCountAvailable(false);
      }
      setIscountapihitcomplete(true);
    } catch (error) {
      Swal.fire({ title: "Oops", text: "Someting went wrong" });
    }
  };

  const datewisereport = async (limitdata) => {
    if (controllerRef.current) controllerRef.current.abort();
    controllerRef.current = new AbortController();
    const { signal } = controllerRef.current;
    let lim = limitdata;
    setIstableapihitcomplete(false);
    setIsDataAvailable(false);
    if (lim == "") lim = 100;
    const sd = searchdataRef.current == "" ? "-1" : searchdataRef.current;
    try {
      await enquirydata(signal);
    } catch (error) {
      if (error.name === "AbortError") { console.log("enquirycount request canceled"); return; }
    }
    try {
      const obj = {
        query: `[dbo].[HCMS_Proc_DatewiseLeads_GetList]@PageNo='{0}',@AgentID='{1}',@Searchdata='{2}',@StartDate='{3}',@EndDate='{4}',@Limit='{5}'`,
        queryArr: [`${pagenumberRef.current}`, `${agentid}`, `${sd}`, `${startdateRef.current}`, `${enddateRef.current}`, `${lim}`],
      };
      const resp = await Hexapi2(obj, { signal });
      if (resp) {
        if (resp.reportdata != undefined && resp.reportdata.length > 0) {
          const keys = Object.keys(resp.reportdata[0]);
          const sortedreportcid = resp.reportdata.map((item) => item.enquiryid);
          const cleanHTML = (html) => { const div = document.createElement("div"); div.innerHTML = html; return div.textContent || div.innerText || ""; };
          const processedData = resp.reportdata.map((item) => ({ contactID: cleanHTML(item["cid"]), stage: item.stageid, customerNumber: item["contact number"] }));
          setHeaderkeys(keys);
          setHeader(resp.reportdata);
          setIsDataAvailable(true);
          setCidarray(sortedreportcid);
          setStageidarr(processedData);
        } else {
          setIsDataAvailable(false);
        }
        setIstableapihitcomplete(true);
      }
    } catch (error) {
      Swal.fire({ title: "Oops", text: "something went wrong" });
    }
  };

  const usageChange = () => {
    setIstableapihitcomplete(false);
    setIsDataAvailable(false);
    const obj = { query: `[dbo].[HCMS_Proc_Organization_Usage_Getdata]@AgentID='{0}'`, queryArr: [`${agentid}`] };
    Hexapi(obj).then((resp) => {
      if (resp[""] != undefined && resp[""].length > 0 && resp[""] != null) {
        const keys = Object.keys(resp[""][0]);
        setHeaderkeys(keys);
        setHeader(resp[""]);
        setIsDataAvailable(true);
      } else {
        setIsDataAvailable(false);
      }
      setIstableapihitcomplete(true);
    });
  };

  const clearSearchbutton = (e, refreshTable = true) => {
    if (e && e.preventDefault) e.preventDefault();
    setSearchdata("");
    searchdataRef.current = "";
    if (!refreshTable) return;
    if (valueRef.current !== "Date wise Report") {
      filterdataapi(appliedFilterRef.current, limitRef.current);
    } else {
      datewisereport(limitRef.current);
    }
  };

const searchbuttonclick = (e) => {
  if (e && e.preventDefault) e.preventDefault();

  const searchdatastore = (searchdataRef.current || "")
    .trim()
    .toLowerCase();

  if (!searchdatastore) {
    setShowSearchInput(false);
    setSearchExecuted(false);

    
    setHeader(originalDataRef.current || []);

    return;
  }

  setSearchdata(searchdatastore);
  setSearchExecuted(true);


  const filteredData = (originalDataRef.current || []).filter((item) =>
    Object.values(item).some((val) =>
      String(val || "")
        .toLowerCase()
        .includes(searchdatastore)
    )
  );

  setHeader(filteredData);
  setIsDataAvailable(filteredData.length > 0);
};
  const pagebuttonclick = (page, e) => {
    setSelectedrowindex(page);
    if (valueRef.current !== "Date wise Report") {
      setPagenumber(page); pagenumberRef.current = page;
      filterdataapi(appliedFilterRef.current, limitRef.current);
    } else if (valueRef.current === "Date wise Report") {
      setPagenumber(page); pagenumberRef.current = page;
      datewisereport(limitRef.current);
    }
  };

const ApplyFilter = (filterString, defaultvalue) => {
  setIsFilterModalOpen(false);

  const selectedString = defaultvalue["Applied For"] || "";
  const selectedPositions = selectedString
    ? selectedString.split(",").map((s) => s.trim()).filter(Boolean)
    : [];

  const allPositionsStr = filters.find((f) => f.filtername === "Applied For")?.values || "";
  const allPositions = allPositionsStr
    ? allPositionsStr.split(",").map((s) => s.trim()).filter(Boolean)
    : [];

  // sirf "sab select" ko clear maano — "kuch bhi select nahi" ko nahi
  const isAllSelected =
    allPositions.length > 0 && selectedPositions.length === allPositions.length;

  setIsfilterclear(isAllSelected);

  const effectiveSelection = isAllSelected ? [] : selectedPositions;
  appliedPositionFilterRef.current = effectiveSelection;
  positionFilterByTabRef.current[leadtypesRef.current] = effectiveSelection;

  if (isAllSelected) {
    // sab select kiya → poora data dikhao
    setHeader(originalDataRef.current || []);
    setTotalcount((originalDataRef.current || []).length);
  } else {
    // 0 select ho ya kuch specific select ho, dono case mein actual filter apply hoga
    // (0 select => .some() kabhi true nahi hoga => filtered array empty ban jaayega)
    const filtered = (originalDataRef.current || []).filter((item) => {
      const itemPositions = toPositionArray(item.appliedposition).map((p) => (p || "").trim());
      return itemPositions.some((pos) => selectedPositions.includes(pos));
    });
    setHeader(filtered);
    setTotalcount(filtered.length);
  }

  setFilters((prevFilters) =>
    prevFilters.map((f) =>
      f.filtername === "Applied For"
        ? { ...f, defval: isAllSelected ? "" : selectedString }
        : f
    )
  );
};

  const clearFilters = () => {
    setIsfilterclear(true);
    setIsFilterModalOpen(false);
    appliedPositionFilterRef.current = [];
    positionFilterByTabRef.current[leadtypesRef.current] = [];
    setHeader(originalDataRef.current || []);
    setTotalcount((originalDataRef.current || []).length);
    setFilters((prevFilters) => prevFilters.map((f) => ({ ...f, defval: "" })));
  };


  const ExitLogout = () => {
    confirmAlert({
      message: "Are you sure you want to Logout? ",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const obj = { query: `[dbo].[HCMS_Proc_User_Logout]@SessionID='{0}'`, queryArr: [`${localStorage.getItem("sessionid")}`] };
            const resp = await Hexapi(obj);
            if (resp && resp[""] && resp[""][0] && resp[""][0].command == 1) {
              localStorage.removeItem("username");
              localStorage.removeItem("password");
              localStorage.removeItem("sessionid");
             navigate("/login")
            }
          },
        },
        { label: "No" },
      ],
      overlayClassName: "confirm__overlayClass",
    });
  };

  const getcallback = (val) => { if (val) filterdataapi(appliedFilterRef.current, limitRef.current); };
  const refreshtable = (val) => { setSelectedrowindex(null); filterdataapi(appliedFilterRef.current, limitRef.current); };
  const refreshtableset = (val) => { setSelectedrowindex(val); };


  const headerParaText = (headerpara || "").toString();

  const isDashboard = value === "Dashboard";

  const menuItems = NAV_SECTIONS.flatMap((section, si) => [
    { type: "group", label: section.group, key: `g${si}` },
    ...section.items.map((item) => ({ key: item.key, icon: item.icon, label: item.label })),
  ]);


  const handleMenuClick = ({ key }) => {
    const navItem = NAV_FLAT.find((n) => n.key == key);
    const tabval = navItem?.tabvalue ?? key;

    tabChange({ preventDefault: () => {} }, tabval == undefined ? key : tabval);
  };

  
  const activeKey = (() => {
    const found = NAV_FLAT.find((n) => (n.tabvalue ?? n.key) === value);
    return found ? found.key : value;
  })();


  const currentNav = NAV_FLAT.find((n) => n.key === activeKey);
  const pageTitle  = currentNav?.label || value;


  if(!agentid){
    <div style={{height:"100vh", display:"flex", justifyContent:"center", alignItems:"center"}}>
    <Loader/>
    </div>
  }
  return (
    <>
      <ReminderNotification AgentID={agentid} open={true} ReminderClick={(EnquiryID) => openActionModal(EnquiryID)} />

      <Layout style={{ minHeight: "100vh" }}>
        <Sider
          collapsed={siderCollapsed}
          width={220}
          collapsedWidth={64}
          theme="light"
          style={{
            borderRight: "0.5px solid #f0f0f0",
            transition: "width 0.2s ease",
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            position: "sticky",
            top: 0,
          }}
        >
         <div
  style={{
    height: 56,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: "0.5px solid #f0f0f0",
    flexShrink: 0,
  }}
>
  {!siderCollapsed && (
    <div
      style={{
        width: 110,
        height: 34,
        borderRadius: 10,
        background: "linear-gradient(135deg, #1250ac, #2f80ed)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontSize: 18,
        fontWeight: 700,
        letterSpacing: 1,
        boxShadow: "0 4px 10px rgba(18, 80, 172, 0.25)",
      }}
    >
      HCMS
    </div>
  )}
</div>

       
          <div style={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}>
            <Menu
              mode="inline"
              selectedKeys={[activeKey]}
              onClick={handleMenuClick}
              items={menuItems}
              style={{ border: "none", fontSize: 13 }}
            />
          </div>

    
          <div style={{ position:"absolute", bottom:"0px",
          width:"100%",
          left:0,
            borderTop: "0.5px solid #f0f0f0",
            padding: "12px 14px",
            display: "flex",
            alignItems: "center",
            gap: 8,
            flexShrink: 0,
            background: "#fff",
          }}>
            <div style={{
              width: 30, height: 30, borderRadius: "50%", background: "#e8f0fe",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 11, fontWeight: 600, color: "#1250ac", flexShrink: 0,
            }}>
              {(agentname || "HR").slice(0, 2).toUpperCase()}
            </div>
            {!siderCollapsed && (
              <>
                <div style={{ flex: 1, minWidth: 0 ,}}>
                  <div style={{ fontSize: 12, fontWeight: 500, color: "#262626", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {agentname || "HR Manager"}
                  </div>
                  <div style={{ fontSize: 11, color: "#8c8c8c" }}>Recruiter</div>
                </div>
             <Tooltip placement="bottom" title="Logout">
  <span
    style={{
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
    }}
    onClick={ExitLogout}
  >
    <FiLogOut
      style={{
        fontSize: "18px",
        color: "gray",
      }}
    />
  </span>
</Tooltip>
              </>
            )}
          </div>
        </Sider>
        <Layout>
          <div style={{
            height: 56, background: "#fff", borderBottom: "0.5px solid #f0f0f0",
            display: "flex", alignItems: "center", justifyContent: "space-between",
            padding: "0 20px", flexShrink: 0,
          }}>
            
            <div>
              {
                (totalcount) && ( <div style={{ fontSize: 15, fontWeight: 600, color: "#262626", lineHeight: 1.2 }}>{pageTitle} ({totalcount})</div> )
              }
             
              {!isDashboard && iscountapihitcomplete && isCountAvailable && isDataAvailable && (
                <div style={{ fontSize: 11, color: "#8c8c8c" }} dangerouslySetInnerHTML={{ __html: totalcounttext }} />
              )}
            </div>

            
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>

             
              {value === "Date wise Report" && (
                <Space size={8}>
                  <Space size={4} align="center">
                    <span style={{ fontSize: 12, color: "#8c8c8c" }}>From</span>
                    <input type="date" value={startdate} onChange={(e) => handledatechagestart(e)}
                      style={{ fontSize: 12, padding: "4px 8px", borderRadius: 6, border: "0.5px solid #d9d9d9", outline: "none" }} />
                  </Space>
                  <Space size={4} align="center">
                    <span style={{ fontSize: 12, color: "#8c8c8c" }}>To</span>
                    <input type="date" value={enddate} onChange={(e) => handledatechageend(e)}
                      style={{ fontSize: 12, padding: "4px 8px", borderRadius: 6, border: "0.5px solid #d9d9d9", outline: "none" }} />
                  </Space>
                </Space>
              )}

              
              {!isDashboard && iscountapihitcomplete && isCountAvailable && isDataAvailable && (
                <Pagination
                  simple size="small"
                  current={Number(pagenumber) || 1}
                  total={Number(totalcount)}
                  pageSize={Number(limit)}
                  onChange={(page, e) => pagebuttonclick(page, e)}
                />
              )}

              {!isDashboard && value !== "Date wise Report" && (
                <Tooltip title="Filter candidates">
                  <Button
                    icon={<FilterOutlined />}
                    onClick={() => setIsFilterModalOpen(true)}
                    style={{ color: isfilterclear ? undefined : "#1250ac" }}
                  />
                </Tooltip>
              )}

           
            

              {!isDashboard && (
                <Space.Compact>
                  {showSearchInput && (
                    <input
                      ref={searchInputRef}
                      type="text"
                      placeholder="Search candidates..."
                      value={searchdata}
                      onChange={(e) => { searchInput(e); setSearchExecuted(false); }}
                      onKeyDown={(e) => { if (e.key === "Enter") searchbuttonclick(e); }}
                      style={{
                        height: 32, padding: "0 10px", fontSize: 13,
                        border: "0.5px solid #d9d9d9", borderRadius: "6px 0 0 6px",
                        outline: "none", width: 190,
                        transition: "width 0.2s ease",
                      }}
                    />
                  )}
                  <Button
                    icon={showSearchInput && searchExecuted && searchdata.trim() ? <span style={{ fontWeight: 700 }}>✕</span> : <SearchOutlined />}
                    onClick={(e) => {
                      if (showSearchInput && searchExecuted && searchdata.trim()) {
                        clearSearchbutton(e, true);
                        setShowSearchInput(false);
                        setSearchExecuted(false);
                      } else {
                        toggleSearchInput();
                      }
                    }}
                    loading={isSearchRunning}
                    style={{ borderRadius: showSearchInput ? "0 6px 6px 0" : 6 }}
                  />
                </Space.Compact>
              )}

           
            

<Tooltip title="Generate Link">
    <Button
                type="primary"
                onClick={() => setshowgeneratelink(true)}
                style={{ background: "#1250ac", borderColor: "#1250ac" }}
              ><IconLink/>
              </Button>
              </Tooltip>
              <Button
                type="primary"
                icon={<PlusOutlined />}
               
                onClick={() => navigate(`/candidate-form?${Aesencryption(
                            `agentID=${agentid}`,
                          )}`)}
                style={{ background: "#1250ac", borderColor: "#1250ac" }}
              >Add Candidate
              </Button>
            </div>
          </div>
          <div style={{ flex: 1, background: "#f5f6fa", padding: 16, overflow: "auto" }}>

            {isFilterModalOpen && (
              <Filter
                isOpenModal={isFilterModalOpen}
                onClose={() => setIsFilterModalOpen(false)}
                filters={filters}
                applyFiltes={(filterString, defaultvalue) => ApplyFilter(filterString, defaultvalue)}
                clearFilters={() => clearFilters()}
                isGoingBack={isfilterclear}
                isStopRefreshing={() => setIsfilterclear(false)}
              />
            )}

          
            {istableapihitcomplete ? (
              isDataAvailable ? (
                value != "Dashboard" ? (
                  <Show
                    processeddata={stageidarr}
                    cidarray={cidarray}
                    headerkeys={headerkeys}
                    header={header}
                    callfunction={getcallback}
                    refreshtable={(e) => refreshtable(e)}
                    agentid={agentid}
                    isnewvalue={isnewvalue}
                    Selectedrowindex={Selectedrowindex}
                    tableRef={tableRef}
                    refreshtableset={(e) => refreshtableset(e)}
                    ref={showRef}
                  />
                ) : (
                  // <Dashboard agentid={agentid} />
                  ""
                )
              ) : (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "60vh", gap: 12 }}>
                  <TeamOutlined style={{ fontSize: 52, color: "#d9d9d9" }} />
                  <span style={{ fontSize: 15, color: "#8c8c8c" }}>No candidates found</span>
                </div>
              )
            ) : (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "60vh" }}>
                <Spin size="large" />
              </div>
            )}
          </div>
        </Layout>
      </Layout>

{
showgeneratelink && 
  <Generatelinks onClose={()=>setshowgeneratelink(false)} open={showgeneratelink} agentid={agentid}/>
}
      {modalshow && (
        <ActionModal
          isdisable={true}
          agentid={agentid}
          modalshow={modalshow}
          recid={recid}
          handleclosemodal={() => setModalshow(false)}
          shortcutclose={true}
        />
      )}

      {addleadshow && (
        <CustomerEnquiryform
          open={addleadshow}
          refreshtableadd={refreshtableadd}
          onClose={() => setaddleadshow(false)}
          agentID={agentid}
        />
      )}
    </>
  );
};

export default Main;